import { render } from "./icon-chain.vue?vue&type=template&id=9cad7f5a"
import script from "./icon-chain.vue?vue&type=script&lang=js"
export * from "./icon-chain.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__